import { ASSISTER_PAGINATION_TYPES } from '@constants/actionTypes/entityActionTypes';

export const INITIAL_STATE = {
    count: 0,
    selectedAssister : null,
    searchAPIInProgress  : false
};

export default (state= INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case ASSISTER_PAGINATION_TYPES.SET_COUNT: {
            return { ...state, count: action.count };
        }

        case ASSISTER_PAGINATION_TYPES.SET_CURRENT_ASSISTER: {                 
            return { ...state, selectedAssister: action.assister };
        }

        case ASSISTER_PAGINATION_TYPES.SET_API_IN_PRG_FLAG:{
            return { ...state, searchAPIInProgress : action.inProgressFlag };
        }

        default:
            return state;
    }
};